import { Close as CloseIcon } from '@atom-learning/icons'
import { Arrow, Close, Content } from '@radix-ui/react-popover'
import * as React from 'react'

import { styled } from '~/styled'

import { ActionIcon } from '../action-icon/ActionIcon'
import { Icon } from '../icon/Icon'

const StyledContent = styled(Content, {
  base: [
    'bg-white',
    'rounded-md',
    'shadow-lg',
    'max-w-[90vw]',
    'p-6',
    'pr-10',
    'relative',
    'z-10',
    'will-change-transform',
    'will-change-opacity',
    'animation-duration-75',
    '[--slide-opacity-out:0]',
    'data-[side=top]:[--slide-direction-out-y:-4px]',
    'data-[side=right]:[--slide-direction-out-x:4px]',
    'data-[side=bottom]:[--slide-direction-out-y:4px]',
    'data-[side=left]:[--slide-direction-out-x:-4px]',
    'motion-safe:data-[state=open]:animate-slide-direction-in',
    'motion-safe:data-[state=closed]:animate-slide-direction-out'
  ],
  variants: {
    size: {
      sm: ['max-w-50'],
      md: ['max-w-100'],
      lg: ['max-w-150']
    }
  }
})

const StyledArrow = styled(Arrow, {
  base: ['fill-white', 'z-1', 'in-data-[align=end]:mx-6']
})

type PopoverContentProps = React.ComponentProps<typeof StyledContent> &
  React.ComponentProps<typeof Content> & {
    closePopoverText?: string
    showCloseButton?: boolean
  }

export const PopoverContent = ({
  children,
  side = 'top',
  sideOffset = 8,
  closePopoverText = 'Close popover',
  showCloseButton = true,
  size = 'md',
  ...remainingProps
}: PopoverContentProps) => (
  <StyledContent
    size={size}
    side={side}
    sideOffset={sideOffset}
    {...remainingProps}
  >
    {showCloseButton && (
      <ActionIcon
        as={Close}
        label={closePopoverText}
        size="md"
        hasTooltip={false}
        theme="neutral"
        className="absolute top-0.5 right-0.5"
      >
        <Icon is={CloseIcon} />
      </ActionIcon>
    )}
    {children}
    <StyledArrow width={16} height={8} />
  </StyledContent>
)
